<div class="css-Ligthbox_consulta_enviada ligthbox_consulta_enviada" id="ligthbox_consulta_enviada">
    <div class="css-Contenido_Ligthbox contenido_ligthbox">
        <div class="css-Icono_consulta_enviada icono_consulta_enviada">
            <img src="assets/images/vectors82891888.svg" width="33.333251953125px" height="33.333374023438px"
                class="css-Vector vector">
        </div>
        <div class="css-Datos_Ligthbox datos_ligthbox">
            <p class="css-Titulo_Ligthbox titulo_ligthbox">Consulta enviada con éxito</p>
            <p class="css-Descripcion_Ligthbox descripcion_ligthbox">Enviaremos la respuesta a la dirección de correo
                declarada.</p>
        </div>
    </div>
    <div class="css-Boton_Ligthbox boton_ligthbox">
        <!-- Instance of sub-component comp-boton-primario -->
        <app-boton-primario-consulta boton_texto="Finalizar" (boton_funcion)="cerrar()"></app-boton-primario-consulta>
    </div>
</div>

<!-- <div class="css-Alerta_Consultenos  alerta_consultenos">
    <div class="css-Contenido contenido">
        <div data-wcfid="icono_confirmacion" class="css-Icono_Confirmacion-1 icono_confirmacion">
            <img src="assets/images/basecomponents-images/alerta-consultenos.svg" width="36.666625976562px"
                height="35px" class="css-verified verified">
        </div>
        <div class="css-Informacion informacion">
            <p class="css-Titulo titulo">Consulta enviada con éxito</p>
            <p class="css-Descripcion descripcion">Enviaremos la respuesta a los correos que asociaste.</p>
        </div>
    </div>
    <div class="css-Acciones acciones">
        <div class="css-TipoSecundario_EstadoInicial tiposecundario_estadoinicial">
            <button type="button" class="css-button_Default-1 button_default" (click)="cerrar()">
                <p class="css-Texto_boton-1 texto_boton">Cerrar el asistente</p>
            </button>
        </div>
        <div class="css-Enlace-1 enlace">
            <a class="css-a_Texto_enlace-1 a_texto_enlace" (click)="nuevaConsulta()">Hacer otra consulta</a>
        </div>
    </div>
</div> -->